import React, { ComponentType } from 'react';
import { Route, Redirect, RouteComponentProps, RouteProps } from 'react-router-dom';
import { AuthContext, AuthContextType, ServicesContext } from '~/services';

interface ProtectedAdminRouteProps extends RouteProps {
    component: ComponentType;
}
export function ProtectedAdminRoute({ component: Component, ...rest }: ProtectedAdminRouteProps) {
    const { authenticated } = React.useContext(AuthContext) as AuthContextType;
    const servicesContext = React.useContext(ServicesContext);
    return (
        <Route
            {...rest}
            render={(props: RouteComponentProps) =>
                authenticated === true &&
                (servicesContext.user.isGlobalAdmin() ||
                    servicesContext.user.isOrganizationAdmin() ||
                    servicesContext.user.isMACLAdmin() ||
                    servicesContext.user.isReportYearAdmin()) === true ? (
                    <Route {...props} component={Component} />
                ) : (
                    <Redirect
                        to={{
                            pathname: '/dashboard',
                            state: { from: props.location },
                        }}
                    />
                )
            }
        />
    );
}
